import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import type { TStoreData } from "../../../../services/api/instances/vectorStoreApi/types";
import { AppButton } from "../../../../shared/components/AppButton";
import { AppInput } from "../../../../shared/components/AppInput";
import { AppLabel } from "../../../../shared/components/AppLabel";
import { AppUnderlinedTitle } from "../../../../shared/components/AppUnderlinedTitle";
import { TrashIcon } from "../../../../shared/icons/TrashIcon";
import { TEntityInfo } from "../../../../common/types/utility";
import styles from "./styles.module.css";
import { DatabaseTitleBlock } from "./DatabaseTitleBlock";

interface Props {
  storeData: TStoreData;
  storeName: string;
  onDeleteDialog: (info: TEntityInfo) => void;
  onNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

export const DatabaseHeader = (props: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <AppUnderlinedTitle
        className={styles.title}
        leftContent={
          <DatabaseTitleBlock
            title={props.storeData.name}
            storeType={props.storeData.metadata.type}
          />
        }
      >
        <AppButton
          onClick={() =>
            props.onDeleteDialog({
              id: props.storeData.id,
              value: props.storeData.name,
            })
          }
          small
          buttonType={"text"}
          icon={<TrashIcon />}
        >
          {t("knowledge_base.delete_button")}
        </AppButton>
      </AppUnderlinedTitle>
      <AppLabel className={styles.label}>
        {"ID: " + props.storeData.id}
      </AppLabel>
      <AppInput
        value={props.storeName}
        onChange={props.onNameChange}
        className={styles.input}
        placeholder={t("knowledge_base.input_name_placeholder")}
        status={props.storeData.status}
      />
    </>
  );
};
